import React, { useState, useEffect, useMemo } from "react";
import axios from "axios";
import * as Yup from "yup";
import { Field, Form, Formik, ErrorMessage } from "formik";
import { useParams, useNavigate, Link } from "react-router-dom";
import Select from "react-select";
import Sidebar from "../../../Dashboard/Sidebar/Sidebar";
import config from "../../../../config/config";
import {
  ALREADY_EXIST,
  AWS_IMAGE_FOLDER_CUSTOMER,
  ERROR_MESSAGE,
  SUCCESS_MESSAGE,
  CUSTOM_SELECT_DROPDOWN_STYLE,
} from "../../../../common/Constant";
import { toastError, toastSuccess } from "../../../../common/Toast";
import Loader from "../../../../components/Loader/Loader";
import { uploadAWS } from "../../../../common/AWSHelper";
import FileInput from "../../../../components/FormControls/FileInput";
import moment from "moment";
import { Modal } from "bootstrap";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/material_blue.css";
import CommonDatePicker from "../../../../components/DatePicker/CommonDatePicker";

const ManageTransfer = (props) => {
  let navigate = useNavigate();
  const paramObject = useParams();
  const token = localStorage.getItem("Token");
  const Id = localStorage.getItem("ID");

  const [TransferFundsFrom, setTransferFundsFrom] = useState([]);
  const [selectedFundsFrom, setSelectedFundsFrom] = useState({});
  const[TranferQuicbookid,setTranferQuicbookid] = useState(0);
  const [loading, setLoading] = useState(false);
  const [birthday, setBirthday] = useState(moment().format("MM-DD-YYYY"));
  const [TransferFundsTo, setTransferFundsTo] = useState([]);
  const [SelectedFundsTo, setSelectedFundsTo] = useState(0);
  const [Amount, setAmount] = useState(0);
  const [Amount2, setAmount2] = useState(0);
  const [TransferAmount, setTransferAmount] = useState("");
  const [StartdateTime, setStartDateTime] = useState("");
  const [btnLoader, setBtnLoader] = useState({ Attachments: false });
  const [ImageUrl, setImageUrl] = useState("");
  const [selectedImage, setSelectedImage] = useState("");
  const [changeImagename, setChangeImagename] = useState(false);
  const [balance, setBalance] = useState(false);
  const [balance1, setBalance1] = useState(false);
  const [modal, setModal] = useState(false);
  const [confirmdata, setConfirmData] = useState({});
  const [transferDetail, setTransferDetail] = useState([]);

  //Setting the default date as a today's date
  const today = moment().format('MM/DD/YYYY');
  // formvalues
  const [formValues, setFormValues] = useState({
    Date: today,
    TransferFundsFrom: "",
    Amount: 0,
    TransferFundsTo: "",
    Memo: "",
    SelectImage: "",
  });

  console.log(formValues.Date,"52528");
  //   validation schema
  const validationSchema = Yup.object().shape({
    TransferFundsFrom: Yup.string().required("Transfer Funds From is Required"),
    TransferFundsTo: Yup.string().required("Transfer Funds To is Required"),
    Amount: Yup.number().required("The Transfer Amount is Required"),
    Date: Yup.string().required("Date is Required"),
  });

  const handleBirthday = (momentDate) => {
    console.log("momentDate::>>", momentDate.target.value);
    setBirthday(moment(momentDate.target.value).format("MM-DD-YYYY"));
  };

  const uploadFile = async (file, type) => {
    setBtnLoader({ [type]: true });
    setLoading(true);
    await uploadAWS(file, AWS_IMAGE_FOLDER_CUSTOMER, (data) => {
      if (data) {
        if (type === "SelectImage") {
          console.log("data: ", data);
          setImageUrl(data);
          setLoading(false);
        }
      }
    });
  };

  const validation = (name, value) => {
    switch (name) {
      case "SelectImage":
        if (!value.name.match(/\.(jpg|jpeg|png|gif)$/)) {
          return false;
        } else {
          return true;
        }
      default: {
        return true;
      }
    }
  };

  const _handleFileChange = (e) => {
    setChangeImagename(true);

    if (validation(e.target.name, e?.currentTarget?.files[0])) {
      uploadFile(e?.currentTarget?.files[0], e.target.name);
    }
  };

  let categoryOption = [];
  const FundsFrom = TransferFundsFrom.map((u, i) => {
    categoryOption[i] = { label: u.Name, value: u.ID, Amount: u.Amount,quickbook: u.QuickbookId };
  });

  let employeeOptions = [];
  const FundsTo = TransferFundsTo.map((u, i) => {
    employeeOptions[i] = {
      label: u.Name,
      value: u.ID,
      Amount: u.Amount,
      quickbookid: u.QuickbookId,
    };
  });

  // Handle Dropdown Data
  const handleDropdownData = (TransferData) => {
    setLoading(true);
    axios
      .get(`${config.accountingBaseUrl}/chartofaccounts/accountddl`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        setTransferFundsFrom(res.data.ResponseData);

        if (TransferData != undefined) {
          // Binding Category data
          let TransferFundsFromList = res.data.ResponseData;

          TransferFundsFromList.map((selectTransferFundsFromList) => {
            if (selectTransferFundsFromList.ID === TransferData.FromAccountID) {
              console.log("TransferData", selectTransferFundsFromList);
              setSelectedFundsFrom({
                label: selectTransferFundsFromList.Name,
                value: selectTransferFundsFromList.ID,
                quickbook :selectTransferFundsFromList.QuickbookId,
              });
              setAmount(selectTransferFundsFromList.Amount);
            }
          });
        }
      });

    axios
      .get(`${config.accountingBaseUrl}/chartofaccounts/accountddl`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        setTransferFundsTo(res.data.ResponseData);
        if (TransferData != undefined) {
          // Binding Category data
          let TransferFundsToList = res.data.ResponseData;

          TransferFundsToList.map((selectTransferFundsToList) => {
            if (selectTransferFundsToList.ID === TransferData.ToAccountID) {
              setSelectedFundsTo({
                label: selectTransferFundsToList.Name,
                value: selectTransferFundsToList.ID,
                quickbookid : selectTransferFundsToList.QuickbookId,

              });
              setAmount2(selectTransferFundsToList.Amount);
            }
          });
        }
      });

    setLoading(false);
  };

  const handleCheck = (event) => {
    setAmount(event.Amount);
    setBalance(true);
  };
  const handleCheck2 = (event) => {
    setAmount2(event.Amount);
    setBalance1(true);
  };

  const handleAmountCheck = (event) => {
    console.log(event.target.value, "event==>");
    setTransferAmount(event.target.value);
    // if (event.target.value > parseFloat(Amount)) {
    //   toastError("Your Transfer Amount is Greater than your Account balance");
    //   // formValues.Amount = 0;
    //   setTransferAmount(0);
    // }
  };

  // Post Data
  const handleSubmit = (values) => {
    console.log(values, "values233");
    if (TransferAmount > 0) {
      const modalElement = document.getElementById("SaveModal");
      const modal = Modal.getOrCreateInstance(modalElement);
      modal.show();
      console.log(SelectedFundsTo, "=====>");
      let TransferData = {
        id: paramObject.id > 0 ? paramObject.id : 0,
        fromaccountid: selectedFundsFrom.value,
        fromaccountquickbookid: selectedFundsFrom.quickbook,
        toAccountid: SelectedFundsTo.value,
        toaccountquickbookid: SelectedFundsTo.quickbookid,

        transferamount: TransferAmount,
        transferdate:values.Date,
        memo: values.Memo,
        attachments: ImageUrl,
        loginuserid: Id,
        redirect: values.buttonType,
        Tranferquickbookid :TranferQuicbookid,
      };
      console.log(TransferData, "datadone===>");
      console.log(TransferData.transferdate, "datadone123===>");
      setConfirmData(TransferData);
    } else {
      toastError("Your transfer amount should be greater than 0");
    }
  };

  // console.log(modal,"modal")

  const ConfirmationSubmit = (e, value) => {
    console.log(confirmdata, "value261");
    setLoading(true)
    axios
      .post(
        `${config.accountingBaseUrl}/chartofaccounts/transfertoaccountupsert`,
        confirmdata,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        if (res.data.ResponseCode === "SUCCESS" && res.data.ResponseID > 0) {
          toastSuccess(SUCCESS_MESSAGE);
          navigate("/transfer");
          if (confirmdata?.redirect == "saveAndNew") {
            navigate("/manage-transfer");
            window.location.reload();
          } else {
            navigate("/transfer");
          }
          setLoading(false);
        } else if (
          res.data.ResponseCode === "ERROR" &&
          res.data.ResponseID === -1
        ) {
          toastError(res.data.ResponseMessage);
        }
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  //API

  const transferDetailsAPI = () => {
    axios
      .get(
        `${config.accountingBaseUrl}/chartofaccounts/transferdetails?id=${paramObject.id}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        console.log("transferdetails", res.data.ResponseData);
        setTransferDetail(res.data.ResponseData);

        let details = res.data.ResponseData[0];
        setAmount(details.FromAccountAmount);
        setBalance(true);
        setAmount2(details.ToAccountAmount);
        setBalance1(true);
        console.log("details.TransferAmount", details?.TransferAmount);
        setTransferAmount(parseFloat(details?.TransferAmount));
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    transferDetailsAPI();
  }, []);

  useEffect(() => {
    //handleDropdownData();

    if (paramObject.id > 0) {
      setLoading(true);

      axios
        .get(
          `${config.accountingBaseUrl}/chartofaccounts/transferhistoryfindByID?id=${paramObject.id}`,
          {
            headers: {
              "Content-Type": "application/json;charset=UTF-8",
              Authorization: token,
            },
          }
        )
        .then((res) => {
          // console.log("response -===>", res.data.ResponseData);

          const transferdata = res.data.ResponseData[0];
          console.log(transferdata , "datahandle");

          setImageUrl(transferdata.Attachements);
          setSelectedImage(transferdata.Attachements);
          setTranferQuicbookid(transferdata.QuickbookId)
          // setBirthday(moment(transferdata.TransferDate).format("MM-DD-YYYY"));

          const data = {
            Date: transferdata.TransferDate,
            TransferFundsFrom: transferdata.FromAccountID,
            Amount: transferdata.TransferAmount,
            TransferFundsTo: transferdata.ToAccountID,
            Memo: transferdata.Memo,
            Attachments: transferdata.Attachements,
            QuickbookID : transferdata.QuickbookId,

          };

          setFormValues(data);
          handleDropdownData(transferdata);

          setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
        });
    } else {
      handleDropdownData();
    }
  }, []);

  console.log(formValues, "formvalues");

  const toggleModal = () => {
    setModal(!modal);
  };

  const handledatechange = (event) => {
    console.log(event , "123000000")

    setFormValues(prev =>{ return {...prev , Date:event}});
  }

  return (
    <>
      <Sidebar />
      <Loader loading={loading} />
      <div className="page-wrapper cardhead">
        <div className="content container-fluid">
          <div
            className="page-header"
            style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}
          >
            <div className="row breadcrumb-position">
              {/* <h3 className="page-title">Transfer</h3> */}
              <ul className="breadcrumb">
                <li className="breadcrumb-item" style={{ marginLeft: "12px" }}>
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/transfer">Transfer List</Link>
                </li>
                <li className="breadcrumb-item active "> New Transfer</li>
              </ul>
            </div>
          </div>
          <div className="card">
            <div className="card-header">
              <p className="card-title p-lg">
                {" "}
                New Transfer (Fields in <span className="text-danger">
                  *
                </span>{" "}
                are required)
              </p>
            </div>
            <Formik
              {...props}
              initialValues={formValues}
              validationSchema={validationSchema}
              onSubmit={handleSubmit}
              enableReinitialize
            >
              {({ errors, touched, handleChange, setFieldValue }) => (
                <Form>
                  {console.log(errors, "errors")}
                  <div className="card-body">
                    {/* row1 */}
                    <div className="row">
                      <div className="col-sm-6">
                        <div className="row mb-3">
                          <label className="col-form-label col-md-4 form-label">
                            Transfer Funds From
                            <span className="text-danger">*</span>
                          </label>

                          <div className="col-md-8">
                            <Select
                              value={
                                categoryOption.find(
                                  (option) =>
                                    option?.value ===
                                    formValues.TransferFundsFrom
                                ) || ""
                              }
                              onChange={(event) => {
                                formValues.TransferFundsFrom = event?.value;
                                formValues.Amount = 0;
                                setTransferAmount(0);
                                // handleChange();
                                setSelectedFundsFrom(event);
                                console.log(event, "data====>");
                                handleCheck(event);
                              }}
                              options={categoryOption}
                              backspaceRemovesValue={false}
                              placeholder="Transfer Funds From"
                              controlShouldRenderValue={true}
                              // hideSelectedOptions={true}
                              isClearable={true}
                              className={`  custom-search-select ${
                                errors.TransferFundsFrom ? "is-invalid" : ""
                              }`}
                              styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                              id="TransferFundsFrom"
                              name="TransferFundsFrom"
                            />

                            <div className="invalid-feedback">
                              {touched.TransferFundsFrom &&
                              errors.TransferFundsFrom
                                ? errors.TransferFundsFrom
                                : ""}
                            </div>
                            {/* <ErrorMessage name="TransferFundsFrom" component="div" className="invalid-feedback" /> */}
                          </div>
                        </div>
                      </div>

                      {balance ? (
                        <div className="col-sm-6">
                          <div className="row mb-3">
                            <label className="col-form-label col-md-2 form-label p-medium">
                              Balance
                            </label>
                            <div className="col-md-10">
                              <p className="p-lg">{formValues.TransferFundsFrom > 0 ? Amount : ""}</p>
                            </div>
                          </div>
                        </div>
                      ) : (
                        ""
                      )}
                    </div>

                    {/* row 2*/}
                    <div className="row">
                      <div className="col-sm-6">
                        <div className="row mb-3">
                          <label className="col-form-label col-md-4 form-label">
                            Transfer Funds To{" "}
                            <span className="text-danger">*</span>
                          </label>

                          <div className="col-md-8">
                            <Select
                              value={
                                employeeOptions.find(
                                  (option) =>
                                    option?.value === formValues.TransferFundsTo
                                ) || ""
                              }
                              //   onChange={(event) => setSelectedFundsTo(event)}
                              onChange={(event) => {
                                console.log(event, "====>");
                                formValues.TransferFundsTo = event?.value;
                                // handleChange()
                                formValues.Amount = 0;
                                setTransferAmount(0);
                                setSelectedFundsTo(event);
                                handleCheck2(event);
                              }}
                              options={employeeOptions}
                              placeholder="Transfer Funds To"
                              backspaceRemovesValue={false}
                              controlShouldRenderValue={true}
                              // hideSelectedOptions={true}
                              isClearable={true}
                              className={`  custom-search-select ${
                                errors.TransferFundsTo ? "is-invalid" : ""
                              }`}
                              styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                              id="TransferFundsTo"
                              name="TransferFundsTo"
                            />
                          
                            <div className="invalid-feedback">
                              {touched.TransferFundsTo && errors.TransferFundsTo
                                ? errors.TransferFundsTo
                                : ""}
                            </div>
                          </div>
                        </div>
                      </div>

                      {balance1 ? (
                        <div className="col-sm-6">
                          <div className="row mb-3">
                            <label className="col-form-label col-md-2 form-label p-medium">
                              Balance
                            </label>
                            <div className="col-md-10 ">
                              <p className="p-lg">{formValues.TransferFundsTo > 0 ? Amount2 : ""}</p>
                            </div>
                          </div>
                        </div>
                      ) : (
                        ""
                      )}
                    </div>

                    {/* row 3 */}
                    <div className="row">
                      <div className="col-sm-6">
                        <div className="form-group row">
                          <label className="col-form-label col-md-4 form-label">
                            Transfer Amount
                            <span className="text-danger">*</span>
                          </label>
                          <div className="col-md-8">
                            <Field
                              type="number"
                              className={`form-control form-control-sm ${
                                errors.Amount ? "is-invalid" : ""
                              }`}
                              //   onChange={handleChange}
                              onChange={(event) => {
                                // console.log(event.target.value, "event")

                                // handleChange(event);
                                handleAmountCheck(event);

                                // const value={...formValues}
                                formValues.Amount = event.target.value;
                                // console.log(formValues.Amount, "formvalues.amount")
                              }}
                              id="Amount"
                              name="Amount"
                              value={TransferAmount}
                              // value={formValues.Amount}
                              // disabled={
                              //   Amount == 0 || Amount == Amount2 ? true : false
                              // }
                            />
                            <div className="invalid-feedback">
                              {touched.Amount && errors.Amount
                                ? errors.Amount
                                : ""}
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-sm-6">
                        <div className="form-group row">
                          <label className="col-form-label col-md-2 form-label">
                            Date
                            <span className="text-danger">*</span>
                          </label>
                          <div className="col-md-4">
                            {/* <input
                              type="date"
                              id="Date"
                              name="Date"
                              value={moment(birthday).format("YYYY-MM-DD")}
                              className="form-control"
                              timeFormat={false}
                              onChange={handleBirthday}
                            /> */}

                            {/* <Flatpickr
                              type="date"
                              className={`form-control form-control-sm ${
                                errors.Date ? "is-invalid" : ""
                              }`}
                              //   onChange={handleChange}
                              onChange={handledatechange}
                              id="Date"
                              name="Date"
                              value={formValues.Date}
                              options={{
                                dateFormat: "m/d/Y",
                                altInput: true,
                                altFormat: "m/d/Y",
                              }}
                            /> */}
                             <CommonDatePicker FinalDate={formValues.Date} handleDateChange={handledatechange}/>
                            <div className="invalid-feedback">
                              {touched.Date && errors.Date ? errors.Date : ""}
                            </div>
                            {/* <ReactDatetime
                              value={birthday}
                              onChange={handleBirthday}
                              id="Date"
                              name="Date"
                              dateFormat="MM-DD-YYYY"
                              timeFormat={false}
                              isValidDate={(currentDate) => {
                                const selectedDate =
                                  moment(currentDate).startOf("day");
                                const today = moment().startOf("day");
                                return selectedDate <= today;
                              }}
                            /> */}
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* row 4 */}

                    <div className="form-group row">
                      <label className="col-form-label col-md-2 form-label">
                        Memo
                      </label>
                      <div className="col-md-8 mt-2">
                        <Field
                          as="textarea"
                          className={`form-control form-control-sm `}
                          id="Memo"
                          name="Memo"
                          rows={5}
                          cols={5}
                        />
                        {/* <div className="invalid-feedback">
                          {touched.Memo && errors.Memo ? errors.Memo : ""}
                        </div> */}
                      </div>
                    </div>

                    {/* row 5 */}
                    <div className="col-sm-6">
                      <div className="form-group row">
                        <label className="col-form-label col-md-4 form-label">
                          Attachments
                        </label>
                        <div className="col-md-8">
                          <FileInput
                            className="form-control form-control-sm"
                            id="SelectImage"
                            name="SelectImage"
                            value={selectedImage}
                            accept="image/*"
                            handleChange={_handleFileChange}
                          />
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-sm-6">
                        <div
                          className={`${
                            ImageUrl ? "" : selectedImage ? "" : "d-none"
                          } form-group row`}
                        >
                          <label className="col-form-label col-md-4 form-label"></label>
                          <div className="col-md-8">
                            <img
                              src={`${ImageUrl ? ImageUrl : selectedImage}`}
                              alt="Category Image"
                              className="ImagePreviewSize"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-sm-6"></div>
                    </div>

                    {/* button */}
                    <div>
                      <div className="pull-right">
                        <button
                          type="submit"
                          // className="confirm-text"
                          to="#"
                          title="Save"
                          data-bs-toggle="modal"
                          className="btn btn-sm btn-primary mb-3 me-3 confirm-text"
                          onClick={() => {
                            setFieldValue("buttonType", "saveAndClose");
                          }}
                        >
                          Save & Close
                        </button>
                        <button
                          type="submit"
                          // className="confirm-text"
                          to="#"
                          title="Save"
                          data-bs-toggle="modal"
                          className="btn btn-sm btn-secondary mb-3 me-3 confirm-text"
                          onClick={() => {
                            setFieldValue("buttonType", "saveAndNew");
                          }}
                        >
                          Save & New
                        </button>
                        <Link
                          to="/transfer"
                          className="btn btn-sm btn-secondary mb-3 "
                        >
                          Cancel
                        </Link>
                      </div>
                      {/* <div
                      style={{
                        display: "flex",
                        gap: "1rem",
                        justifyContent: "flex-end",
                      }}
                    >
                      <button
                        type="submit"
                        className="btn btn-primary mt-3 mb-3"
                        onClick={() => {
                          setFieldValue("buttonType", "saveAndClose");
                        }}
                      >
                        Save & Close
                      </button>
                      <button
                        type="submit"
                        className="btn btn-primary mt-3 mb-3"
                        onClick={() => {
                          setFieldValue("buttonType", "saveAndNew");
                        }}
                      >
                        Save & New
                      </button>
                    </div> */}
                    </div>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>
      </div>

      {/* {console.log(modal,"mymodal")} */}
      {/* {modal ? 
      <div
        class="modal fade"
        data-bs-backdrop="static"
        id="SaveModal"
        tabindex="-1"
        aria-labelledby="SaveModal"
        aria-hidden="true"
      >
        <div
          class="modal-dialog modal-sm modal-dialog-centered"
        
        >
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Confirmation</h5>
              <button
                type="button"
                className="close"
                data-bs-dismiss="modal"
                aria-label="Close"
                // onClick={()=>navigate("/manage-transfer")}
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="row">
                <div className="col-lg-12">
                  <h6>Are you sure you want to make this transfer?</h6>
                </div>
              </div>
            </div>
            <div className="modal-footer justify-content-center">
              <Link
                to="#"
                className="btn btn-primary btn-md me-1"
                data-bs-dismiss="modal"
                onClick={ConfirmationSubmit}
              >
                Save{" "}
              </Link>
              <Link
                to="#"
                className="btn btn-dark btn-md me-1"
                data-bs-dismiss="modal"
                
              >
                Cancel{" "}
              </Link>
            </div>
          </div>
        </div></div> : ""} */}

      {/* {console.log(modal,"mymodal")} */}

      {/* {modal && ( */}

      <>
        <div
          className="modal fade"
          // data-bs-backdrop={false}

          id="SaveModal"
          tabIndex={-1}
          aria-labelledby="Save"
          // aria-hidden="true"
          data-bs-keyboard="false"
        >
          <div className="modal-dialog modal-sm modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="title-model">Confirmation</h5>
                <button
                  type="button"
                  className="close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={toggleModal} // Add this onClick handler to close the modal when the close button is clicked
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="modal-body">
                <div className="row">
                  <div className="col-lg-12">
                    <p>Are you sure you want to make this transfer?</p>
                  </div>
                </div>
              </div>
              <div className="modal-footer justify-content-center">
                <button
                  className="btn btn-primary btn-md me-1"
                  data-bs-dismiss="modal"
                  onClick={(e) => ConfirmationSubmit(e, "saveAndNew")}
                >
                  Save
                </button>
                <button
                  className="btn btn-dark btn-md me-1"
                  data-bs-dismiss="modal"
                  onClick={toggleModal} // Add this onClick handler to close the modal when the 'Cancel' button is clicked
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
        {/* <div class="modal-backdrop fade show"></div> */}
      </>
      {/* )} */}
    </>
  );
};

export default ManageTransfer;
